export const TOP_BAR_HEIGHT = 50
export const BOTTOM_BAR_HEIGHT = 50
export const AD_HEIGHT = 250
export const SNACKBAR_HEIGHT = 60
export const OUTER_WIDTH = 1024
export const NARROW_INNER_WIDTH = 460
export const INNER_WIDTH = 768
export const TRANSITION_TIME = 250
